import * as React from "react";
import { I18nextProvider } from "react-i18next";
import type { WrapPageElementBrowserArgs } from "gatsby";

export const wrapPageElement = (
  { element }: WrapPageElementBrowserArgs,
  props: any
) => {
  const i18n = props.pageContext?.i18n;

  if (!i18n) return element;

  return <I18nextProvider i18n={i18n}>{element}</I18nextProvider>;
};
